import { getSubTags, hasTag } from '../../util/tag-utils';
var CreditCardsComponent = /** @class */ (function () {
    function CreditCardsComponent() {
        this.hasTag = hasTag;
    }
    Object.defineProperty(CreditCardsComponent.prototype, "hasContent", {
        get: function () {
            return getSubTags(this.tags, 'Credit Cards::').length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreditCardsComponent.prototype, "nonAOPAMasterCardCreditCards", {
        get: function () {
            var result = [];
            for (var _i = 0, _a = this.tags; _i < _a.length; _i++) {
                var currentTag = _a[_i];
                if (currentTag.tagName.startsWith('Credit Cards::') &&
                    !currentTag.tagName.includes('AOPA Mastercard')) {
                    result.push(currentTag.displayName);
                }
            }
            return result.sort();
        },
        enumerable: true,
        configurable: true
    });
    return CreditCardsComponent;
}());
export { CreditCardsComponent };
